import React from "react";
import WelcomeIcon from "../Icons/WelcomeIcon";
import WelcomeText from "../WelcomePost/WelcomeText";

const SlackInvitationPost = (props) => {
  return (
    <div className="welcome-slack">
      <WelcomeIcon />
      <WelcomeText
        userName={props.userName}
        welcomeText="Check your email for an invitation to our Slack. We'll get you sorted into a crew as soon as we can. In the meantime, watch our onboarding video."
      />
    </div>
  );
};

export default SlackInvitationPost;
